import React, { useState, useEffect } from "react";
import { styled } from '@mui/material/styles';
import Tabs from "./Tabs";
import Drawer from "./Drawer";
import Search from "./Search";
import Alert from "./Alert";
import Modal from "./Modal";
import { IconButton } from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import { useHistory } from "react-router-dom";
import "../../../dsl-assets/css/styles.css";
const PREFIX = 'Header';

const classes = {
  spacer: `${PREFIX}-spacer`,
  header: `${PREFIX}-header`,
  headerContent: `${PREFIX}-headerContent`,
  title: `${PREFIX}-title`,
  tabs: `${PREFIX}-tabs`,
  drawer: `${PREFIX}-drawer`,
  content: `${PREFIX}-content`,
  help: `${PREFIX}-help`,
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.spacer}`]: {
    // padding: "0.7em 7em",
    // display: "flex",
    width: "100%",
    // zIndex: -1,
    // alignItems: "center",
    // background: "#0078a9",
    // justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      // padding: "1em 0",
      // justifyContent: "center",
    },
  },

  [`& .${classes.header}`]: {
    padding: "0.3em 0em",
    display: "flex",
    alignItems: "center",
    // justifyContent: "space-between",
    flexDirection: "column",
    width: "100%",
    zIndex: 1199,
    background: "#0078a9",
    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
    [theme.breakpoints.down("sm")]: {
      padding: "0.5em 0",
      justifyContent: "center",
    },
	"& .MuiButtonBase-root": {
		color: "#fff",
	},
  },

  [`& .${classes.headerContent}`]: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    // margin: "0 7rem",
    width: "90%",
  },

  [`& .${classes.title}`]: {
    color: "#fff",
    fontSize: "1.5rem",
    transition: "100ms",
    "&:hover": {
      cursor: "pointer",
      textShadow: "0 2px 5px rgba(0,0,0,0.2)",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },

  [`& .${classes.tabs}`]: {
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },

  [`& .${classes.drawer}`]: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
    },
  },

  [`& .${classes.content}`]: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      justifyContent: "center",
    },
  },

  [`& .${classes.help}`]: {
    color: "#fff",
  }
  
}));

const Header = () => {

  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [spacerHeight, setSpacerHeight] = useState();

  const openModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    if (open) {
      setOpen(false);
    }
  };

  const onClickHeader = () => {
    history.push("about");
  };

  const sizeHeaderSpacer = () => {
    document.getElementById("header-content") &&
      setSpacerHeight(
        `${document.getElementById("header-content").scrollHeight}px`
      );
  };

  useEffect(() => {
    window.addEventListener("resize", sizeHeaderSpacer);
    sizeHeaderSpacer();
  }, []);

  return (
    <Root className={classes.root}>
      <>
      <div><Alert /></div>
      <div id="header" className={classes.header} onClick={closeModal}>
        <div id="header-content" className={classes.headerContent}>
          <h1
            onClick={onClickHeader}
            className={classes.title}
            role="heading"
            aria-level="1"
          >
            Hazus Loss Library
          </h1>
          
          <div className={classes.content}>
            <div className={classes.tabs}>
              <Tabs />
            </div>
            <div className={classes.drawer}>
              <Drawer />
            </div>
            <Search />
            {/* <IconButton
            onClick={openModal}
            alt="info"
            aria-label="show app help info"
          >
            <HelpIcon className={classes.help} />
          </IconButton> */}
          </div>
          {/* <Modal open={open} /> */}
        </div>
      </div>
      <div className={classes.spacer}></div>
     </></Root>
  );
};

export default Header;
